import { Component, OnInit } from '@angular/core';
import { EregistrationsTranslationService } from '../../../services/eregistrations-translation.service';
import { environment } from '../../../../environments/environment';
import { AuthService } from '../../../services/auth/auth-service';
import { GlobalStateProviderService } from '../../../services/global-state-provider.service';
import { BehaviorSubject, filter, Observable, switchMap } from 'rxjs';

@Component({
  selector: 'app-user-menu',
  templateUrl: './user-menu.component.html'
})
export class UserMenuComponent implements OnInit {
  BASE_URL = environment.BASE_URL;
  authAdminUrl: string | null = null;
  bpaUrl: string | null = null;
  statsUrl: string | null = null;
  protected USE_OLD_FE = environment.USE_OLD_FE;
  protected USE_NEW_PART_B_LINK = environment.USE_NEW_PART_B_LINK;
  protected keycloakActive = environment.KEYCLOAK_ACTIVE;
  public userIsSuperinspector: boolean = false;
  public userIsSuperMario: boolean = false;
  public userIsPartB: boolean = false;
  public userIsSysadmin: boolean = false;
  private readonly logoutClickedBehaviorSubject = new BehaviorSubject<boolean>(
    false
  );
  private readonly logoutClicked$: Observable<boolean> =
    this.logoutClickedBehaviorSubject.asObservable();

  constructor(
    public authService: AuthService,
    public globalStateProviderService: GlobalStateProviderService,
    public eregistrationsTranslationService: EregistrationsTranslationService
  ) {
    this.logoutClicked$
      .pipe(
        filter((clicked) => clicked),
        switchMap(() => this.authService.logout(window.location.origin))
      )
      .subscribe({});
    if (environment.KEYCLOAK_ACTIVE) {
      this.authAdminUrl = environment.KEYCLOAK_URL;
    } else {
      this.authAdminUrl = environment.PARTC_URL;
    }
    if (environment.BPA_URL) {
      this.bpaUrl = environment.BPA_URL;
    } else {
      const baseDomain = this.BASE_URL.replace(/^https?:\/\/(services\.)?/, '');
      this.bpaUrl = `https://bpa.${baseDomain}`;
    }
    if (environment.STATS_URL) {
      this.statsUrl = environment.STATS_URL;
    } else {
      const baseDomain = this.BASE_URL.replace(/^https?:\/\/(services\.)?/, '');
      this.statsUrl = `https://stats.${baseDomain}`;
    }
  }

  ngOnInit() {
    this.authService.jwt$.subscribe((jwt) => {
      if (jwt) {
        this.getUserIsSuperinspector().subscribe((isSuperinspector) => {
          this.userIsSuperinspector = isSuperinspector;
        });
        this.getUserIsSuperMario().subscribe((isSuperMario) => {
          this.userIsSuperMario = isSuperMario;
        });
        this.getUserIsPartB().subscribe((isPartB) => {
          this.userIsPartB = isPartB;
        });
        this.getUserIsSysadmin().subscribe((isSysadmin) => {
          this.userIsSysadmin = isSysadmin;
        });
      } else {
        this.userIsSuperinspector = false;
        this.userIsSuperMario = false;
        this.userIsPartB = false;
        this.userIsSysadmin = false;
      }
    });
  }

  private getUserIsSuperinspector(): Observable<boolean> {
    return new Observable<boolean>((observer) => {
      if (this.authService.keycloakActive) {
        observer.next(this.authService.keycloak.isUserInRole('superinspector'));
        observer.complete();
      } else {
        this.authService.cas
          .isUserInRole('superinspector')
          .subscribe((result) => {
            observer.next(result);
            observer.complete();
          });
      }
    });
  }

  private getUserIsSuperMario(): Observable<boolean> {
    return new Observable<boolean>((observer) => {
      if (this.authService.keycloakActive) {
        observer.next(this.authService.keycloak.isUserInRole('super_mario'));
        observer.complete();
      } else {
        this.authService.cas.isUserInRole('super_mario').subscribe((result) => {
          observer.next(result);
          observer.complete();
        });
      }
    });
  }

  private getUserIsPartB(): Observable<boolean> {
    return new Observable<boolean>((observer) => {
      if (this.authService.keycloakActive) {
        observer.next(this.authService.keycloak.isUserInRole('partb'));
        observer.complete();
      } else {
        this.authService.cas.isUserInRole('partb').subscribe((result) => {
          observer.next(result);
          observer.complete();
        });
      }
    });
  }

  private getUserIsSysadmin(): Observable<boolean> {
    return new Observable<boolean>((observer) => {
      if (this.authService.keycloakActive) {
        observer.next(this.authService.keycloak.isUserInRole('sysadmin'));
        observer.complete();
      } else {
        this.authService.cas.isUserInRole('sysadmin').subscribe((result) => {
          observer.next(result);
          observer.complete();
        });
      }
    });
  }

  public logout() {
    this.logoutClickedBehaviorSubject.next(true);
  }
}
